import { AT } from '../actions/actionTypes';
import { FeedbackState, Feedback, FeedbackType } from '../interfaces';
import { FeedbackAddPL, FeedbackContent } from '../models';
import Logger from '../libs/logger'; import { LogArea } from '../libs/logger/const';

const defaultState: FeedbackState = {
  feedbacks: [],
};

const markFeedbackAsRead = (list: Feedback[], item: Feedback) => {
  const idx = list.findIndex((p) => p.timestamp === item.timestamp);
  if (idx !== -1) {
    const updatedItem = { ...list[idx], displayed: true };
    return [...list.slice(0, idx), updatedItem, ...list.slice(idx + 1)];
  }
  return list;
};

const createFeedback = (
  feedbackType: FeedbackType,
  content: FeedbackContent
): Feedback => {
  return {
    type: feedbackType,
    header: content,
    timestamp: Date.now(),
    displayed: false,
  };
};

const createSuccessFeedback = (content: FeedbackContent): Feedback => {
  return createFeedback(FeedbackType.SUCCESS, content);
};

const createErrorFeedback = (content: FeedbackContent): Feedback => {
  return createFeedback(FeedbackType.ERROR, content);
};

const createWarningFeedback = (content: FeedbackContent): Feedback => {
  return createFeedback(FeedbackType.WARNING, content);
};

export default function (state = defaultState, action: any) {
  switch (action.type) {
    case AT.FEEDBACK_ADD_ERROR:
      Logger.info([AT.FEEDBACK_ADD_ERROR, action], LogArea.Redux);
      const { content }: FeedbackAddPL = action.payload;
      const feedbacks = [
        ...state.feedbacks,
        ...content.map((m) => createErrorFeedback(m)),
      ];
      return { ...state, feedbacks };

    case AT.DIALOG_REGISTER_SUCCESS:
    case AT.FEEDBACK_ADD_SUCCESS: {
      Logger.info([AT.FEEDBACK_ADD_SUCCESS, action], LogArea.Redux);
      const { content }: FeedbackAddPL = action.payload;
      const feedbacks = [
        ...state.feedbacks,
        ...(content || []).map((m) => createSuccessFeedback(m)),
      ];
      return { ...state, feedbacks };
    }
    case AT.FEEDBACK_ADD_WARNING: {
      Logger.info([AT.FEEDBACK_ADD_WARNING, action], LogArea.Redux);
      const { content }: FeedbackAddPL = action.payload;
      const feedbacks = [
        ...state.feedbacks,
        ...(content || []).map((m) => createWarningFeedback(m)),
      ];
      return { ...state, feedbacks };
    }
    case AT.FEEDBACK_SEEN: {
      Logger.info([AT.FEEDBACK_SEEN, action], LogArea.Redux);
      const inputFeedback: Feedback = action.payload;
      const feedbacks = markFeedbackAsRead(state.feedbacks, inputFeedback);
      return { ...state, feedbacks };
    }
    default: {
      return state;
    }
  }
}
